import { AnalyticsRoutes } from "Pages/Analytics/Routes"
import {
	CatalogueRoutes, DigitalShelfRoutes, HomeRoutes, IaOptionsRoutes, InfoCenterRoutes, MarketplacesRoutes, PricingRoutes,
	RepricingRoutes, SessionRoutes, ProductPageRoutes, StockRoutes, ShareOfSearchRoutes, ShareOfBrowseRoutes, NotFoundRoutes,
	AdminRoutes, SkuDetailsRoutes, ReportsRoutes, CustomDashboardRoutes, CustomDashboardPrimorRoutes, ManagementRoutes, MonitoringRoutes, BannersRoutes, NewsManagementRoutes
} from './Pages'


const routes = [
	HomeRoutes,
	PricingRoutes,
	RepricingRoutes,
	MarketplacesRoutes,
	StockRoutes,
	DigitalShelfRoutes,
	ProductPageRoutes,
	ShareOfBrowseRoutes,
	ShareOfSearchRoutes,
	CatalogueRoutes,
	IaOptionsRoutes,
	SkuDetailsRoutes,
	AnalyticsRoutes,
	...SessionRoutes,
	NotFoundRoutes,
	MonitoringRoutes,
	BannersRoutes,
	ReportsRoutes,
	CustomDashboardRoutes,
	CustomDashboardPrimorRoutes,
	InfoCenterRoutes,
	ManagementRoutes,
	NewsManagementRoutes,
	AdminRoutes,
]

export default routes